<!-- <p-toast position="top-right"></p-toast>

<merchant-create-product [_showMerchantCreateProductSideBar]="showMerchantCreateProductSideBar"
                         [merchantProductsComponent]="this"
                         (changedShowMerchantCreateProductSideBarEmit)="changedShowMerchantCreateProductSideBarEmit($event)"
                         *ngIf="showMerchantCreateProductSideBar"></merchant-create-product>

<merchant-edit-product [_showMerchantEditProductSideBar]="showMerchantEditProductSideBar"
                       [_productId]="productId"
                       [merchantProductsComponent]="this"
                       (changedShowMerchantEditProductSideBarEmit)="changedShowMerchantEditProductSideBarEmit($event)"
                       *ngIf="showMerchantEditProductSideBar"></merchant-edit-product>

<merchant-detail-product [_showMerchantDetailProductSideBar]="showMerchantDetailProductSideBar"
                         [_productId]="productId"
                         [merchantProductsComponent]="this"
                         (changedShowMerchantDetailProductSideBarEmit)="changedShowMerchantDetailProductSideBarEmit($event)"
                         *ngIf="showMerchantDetailProductSideBar"></merchant-detail-product>

<merchant-approved-reject-product [_showMerchantApprovedRejectProductSideBar]="showMerchantApprovedRejectProductSideBar"
                                  [_productId]="productId" [_merchantId]="merchantId"
                                  [merchantProductsComponent]="this"
                                  (changedShowMerchantApprovedRejectProductSideBarEmit)="changedShowMerchantApprovedRejectProductSideBarEmit($event)"
                                  *ngIf="showMerchantApprovedRejectProductSideBar && !isMerchant"></merchant-approved-reject-product> -->
<merchant-products-sidebar
	[showViewProductSidebar]="showViewProductSidebar"
></merchant-products-sidebar>
<mat-drawer-container class="draw-container store-view-tab-content mt-5" autosize>
	<mat-drawer #drawer class="sidenav-draw-container" mode="side" position="end">
		<!-- Filter -->
		<product-filter
			(applyFilter)="onFilterMerchantProduct($event)"
			(closeDrawer)="drawer.close()"
			(cancelFilter)="getProductsByMerchant(0)"
		>
		</product-filter>
	</mat-drawer>

	<div class="sidenav-content">
        <div class="tab-title mb-2 ml-4">Inventory</div>

		<div class="flex justify-content-between flex-wrap pb-2">
			<div class="flex align-content-center flex-wrap gap-3">
                <mat-form-field class="ml-4 mt-3 w-500px custom-search-field" appearance="fill">
                    <mat-icon matPrefix class="text-gray-500">
                        search
                    </mat-icon>
                    <input matInput type="text"
                           [(ngModel)]="filter.searchName"
                           (input)="handleFilterChange()"
                           placeholder="Search Product"
                           [disabled]="isActionDisabled()" />
                </mat-form-field>

                <div class="inventory-buttons mt-4">
                    <div>
                        <button mat-icon-button (click)="changeView(viewMode.TableView)">
                            <mat-icon color="primary">
                                <span class="material-symbols-outlined"> view_list </span>
                            </mat-icon>
                        </button>
                        <button mat-icon-button (click)="changeView(viewMode.GridView)">
                            <mat-icon color="primary">grid_on </mat-icon>
                        </button>
                    </div>

                    <span class="separator-line align-self-center"></span>
                    <button mat-button class="filter-button align-self-center" (click)="drawer.toggle()">
						<mat-icon>filter_alt</mat-icon>
						<span class="button-filter-label">Filter</span>
					</button>
                    <button
                            mat-flat-button
                            color="primary"
                            (click)="openAddProductDialog()"
                            class="align-self-center"
                            [disabled]="isActionDisabled()"
                            [matTooltip]="isActionDisabled() ? 'No internet connection' : ''"
                    >
                        Add New
                        <mat-icon> add_circle </mat-icon>
                    </button>
                </div>
			</div>
		</div>
		<div class="container mat-elevation-z8 ml-3">
			@if (noInternetConnection && productItems.length === 0) {
			<div
				class="flex justify-content-center flex-wrap align-items-center h-30rem"
			>
				<div class="flex flex-column">
					<mat-icon class="mb-3" style="font-size: 64px; color: #ccc;">
						wifi_off
					</mat-icon>
					<div class="flex align-items-center justify-content-center mb-2">
						<p class="font-medium text-center">No Internet Connection</p>
					</div>
					<div class="text-center text-gray-600 mb-3">
						Please check your internet connection and try again.
					</div>
					<button
						mat-flat-button
						color="primary"
						(click)="checkInternetConnection(); getProductsByStore(0)"
						class="align-self-center"
					>
						<mat-icon>refresh</mat-icon>
						Retry
					</button>
				</div>
			</div>
			} @if (noInternetConnection && productItems.length > 0) {
			<!-- Connection status banner -->
			<div class="connection-status-banner">
				<div class="flex align-items-center justify-content-between p-3" style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px; margin-bottom: 16px;">
					<div class="flex align-items-center">
						<mat-icon style="color: #856404; margin-right: 8px;">wifi_off</mat-icon>
						<span style="color: #856404; font-weight: 500;">No Internet Connection - Showing cached data</span>
					</div>
					<button
						mat-icon-button
						(click)="checkInternetConnection(); getProductsByStore(0)"
						style="color: #856404;"
						matTooltip="Retry connection"
					>
						<mat-icon>refresh</mat-icon>
					</button>
				</div>
			</div>
			} @if (loading) {
			<div class="loading-shade">
				@if (loading) {
				<mat-spinner></mat-spinner>
				}
			</div>
			} @if(productItems.length > 0) { @if(viewMode.TableView ===
			selectedViewMode) {
			<product-table-view
				[productItems]="productItems"
				[productRowsPerPage]="productRowsPerPage"
				[productRowsPerPageOptions]="productRowsPerPageOptions"
				[productPageIndex]="productPageIndex"
				[productTotalRecords]="productTotalRecords"
				(loadProducts)="handleProductLazyLoadTable($event)"
				(showViewProductSidebarEmit)="showViewProductSidebarEmit($event)"
				(viewProductDialog)="openViewProductDialog($event)"
			>
			</product-table-view>
			} @if (loading) {
			<div class="loading-shade">
				@if (loading) {
				<mat-spinner></mat-spinner>
				}
			</div>
			} @if(viewMode.GridView === selectedViewMode){
			<product-grid-view
				[productItems]="productItems"
				(loadProducts)="handleLazyLoadGrid($event)"
				(editProduct)="openEditProductDialog($event)"
				(viewProduct)="openViewProductDialog($event)"
			>
			</product-grid-view>
			} }@if(!loading && productItems.length === 0 && !noInternetConnection) {
			<div
				class="flex justify-content-center flex-wrap align-items-center h-30rem"
			>
				<div class="flex flex-column">
					<img
						src="/XpressApp/assets/images/product/no-product.svg"
						alt="No products"
					/>
					<div class="flex align-items-center justify-content-center">
						<p class="font-medium">No product yet</p>
					</div>
					<div>You’ll able to see your products here.</div>
				</div>
			</div>
			}
		</div>
	</div>
</mat-drawer-container>
